import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import * as XLSX from 'xlsx';
 
const MESICE = ['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec'];
const ZAKAZKA_NESCHOPNOST = 'Pracovní neschopnost';
const ZAKAZKA_LEKAR = 'Návštěva lékaře';

export default function PrehledJednatel() {
  const now = new Date();
  const [rok, setRok] = useState(now.getFullYear());
  const [mesic, setMesic] = useState(now.getMonth() + 1);
  const [tab, setTab] = useState('zamestnanci');
  const [zakazkyPohled, setZakazkyPohled] = useState('mesic');
  const [hledani, setHledani] = useState('');
  const [vykazy, setVykazy] = useState({ mesic: [], vsechny: [] });
  const [uzivatele, setUzivatele] = useState([]);
  const [zakazky, setZakazky] = useState([]);
  const [dovolene, setDovolene] = useState([]);
  const [loading, setLoading] = useState(true);
 
  useEffect(() => { fetchData(); }, [rok, mesic]);
  useEffect(() => { setHledani(''); }, [tab]);
 
  const fetchData = async () => {
    setLoading(true);
    const od = `${rok}-${String(mesic).padStart(2,'0')}-01`;
    const do_ = `${rok}-${String(mesic).padStart(2,'0')}-${new Date(rok, mesic, 0).getDate()}`;
 
    const [vRes, uRes, zRes, dRes] = await Promise.all([
      supabase.from('vykazy').select('*, cas_od, cas_do, zakazky(id, nazev), uzivatele!vykazy_zamestnanec_id_fkey(jmeno, role)').eq('stav','schváleno').gte('datum', od).lte('datum', do_),
      supabase.from('uzivatele').select('*, vedouci:vedouci_id(jmeno)').eq('aktivni', true).order('jmeno'),
      supabase.from('zakazky').select('*').order('nazev'),
      supabase.from('dovolena').select('*, zamestnanec:zamestnanec_id(jmeno, email, dovolena_narok), schvalil:schvalil_id(jmeno)').eq('rok', rok).order('datum_od', { ascending: true }),
    ]);

    // Nacti vsechny vykazy po davkach (obchazi limit 1000)
    const vsechnyAll = [];
    let from = 0;
    const batchSize = 1000;
    while (true) {
      const { data: batch, error } = await supabase
        .from('vykazy')
        .select('*, cas_od, cas_do, zakazky(id, nazev), uzivatele!vykazy_zamestnanec_id_fkey(jmeno, role)')
        .eq('stav','schváleno')
        .range(from, from + batchSize - 1);
      if (error || !batch || batch.length === 0) break;
      vsechnyAll.push(...batch);
      if (batch.length < batchSize) break;
      from += batchSize;
    }
    const vsechnyRes = { data: vsechnyAll };
 
    console.log("vsechny data:", vsechnyRes.data?.length, "error:", vsechnyRes.error?.message);
    setVykazy({ mesic: vRes.data || [], vsechny: vsechnyRes.data || [] });
    setUzivatele(uRes.data || []);
    setZakazky(zRes.data || []);
    setDovolene(dRes.data || []);
    setLoading(false);
  };
 
  const exportExcel = () => {
    const wb = XLSX.utils.book_new();

    // List 1 – Výkazy práce
    const rowsVykazy = vykazy.mesic.map(v => ({
      'Datum': v.datum,
      'Zaměstnanec': v.uzivatele?.jmeno,
      'Zakázka': v.zakazky?.nazev,
      'Od': v.cas_od || '',
      'Do': v.cas_do || '',
      'Hodiny': v.hodiny,
      'Poznámka': v.poznamka || '',
    }));
    const wsVykazy = XLSX.utils.json_to_sheet(rowsVykazy);
    XLSX.utils.book_append_sheet(wb, wsVykazy, `Výkazy ${MESICE[mesic-1]} ${rok}`);

    // List 2 – Dovolené (celý rok)
    const rowsDovolena = dovolene.map(d => ({
      'Zaměstnanec': d.zamestnanec?.jmeno || '',
      'Email': d.zamestnanec?.email || '',
      'Datum od': d.datum_od,
      'Datum do': d.datum_do,
      'Počet dní': d.pocet_dni,
      'Stav': d.stav,
      'Schválil': d.schvalil?.jmeno || '',
      'Poznámka': d.poznamka || '',
    }));
    const wsDovolena = XLSX.utils.json_to_sheet(rowsDovolena);
    XLSX.utils.book_append_sheet(wb, wsDovolena, `Dovolená ${rok}`);

    // List 3 – Celkový přehled pro mzdy
    const hodinyMap = {};
    const neschopnostMap = {};
    const lekarMap = {};

    vykazy.mesic.forEach(v => {
      const jmeno = v.uzivatele?.jmeno || '';
      const nazev = v.zakazky?.nazev?.trim() || '';
      const h = parseFloat(v.hodiny || 0);

      if (nazev === ZAKAZKA_NESCHOPNOST) {
        neschopnostMap[jmeno] = (neschopnostMap[jmeno] || 0) + h;
      } else if (nazev === ZAKAZKA_LEKAR) {
        lekarMap[jmeno] = (lekarMap[jmeno] || 0) + h;
      } else {
        hodinyMap[jmeno] = (hodinyMap[jmeno] || 0) + h;
      }
    });

    const posledniDenMesice = `${rok}-${String(mesic).padStart(2,'0')}-${new Date(rok, mesic, 0).getDate()}`;
    const cerpaniMap = {};
    dovolene
      .filter(d => d.stav === 'schváleno' && d.datum_od <= posledniDenMesice)
      .forEach(d => {
        const jmeno = d.zamestnanec?.jmeno || '';
        cerpaniMap[jmeno] = (cerpaniMap[jmeno] || 0) + d.pocet_dni;
      });

    const rowsPrehled = uzivatele
      .filter(u => u.role === 'zamestnanec' || u.role === 'vedouci' || u.role === 'hr' || u.role === 'jednatel')
      .map(u => {
        const narok = u.dovolena_narok ?? 20;
        const cerpano = cerpaniMap[u.jmeno] || 0;
        return {
          'Zaměstnanec': u.jmeno,
          'Email': u.email,
          'Odpracované hodiny': hodinyMap[u.jmeno] || 0,
          'Pracovní neschopnost (h)': neschopnostMap[u.jmeno] || 0,
          'Návštěva lékaře (h)': lekarMap[u.jmeno] || 0,
          'Dovolená čerpáno (dní)': cerpano,
          'Dovolená zbývá (dní)': narok - cerpano,
          'Nárok (dní)': narok,
        };
      });
    const wsPrehled = XLSX.utils.json_to_sheet(rowsPrehled);
    XLSX.utils.book_append_sheet(wb, wsPrehled, `Přehled ${MESICE[mesic-1]} ${rok}`);

    // List 4 – Přehled zakázek (agregace podle ID, ne názvu)
    const hodinyMesicMap = {};
    vykazy.mesic.forEach(v => {
      const id = v.zakazky?.id || '';
      hodinyMesicMap[id] = (hodinyMesicMap[id] || 0) + parseFloat(v.hodiny || 0);
    });
    const hodinyVsechnyMap = {};
    vykazy.vsechny.forEach(v => {
      const id = v.zakazky?.id || '';
      hodinyVsechnyMap[id] = (hodinyVsechnyMap[id] || 0) + parseFloat(v.hodiny || 0);
    });
    const rowsZakazky = zakazky.map(z => ({
      'Zakázka': z.nazev,
      'Stav': z.uzavrena ? 'Uzavřena' : 'Aktivní',
      'Hodin tento měsíc': hodinyMesicMap[z.id] || 0,
      'Hodin celkem': hodinyVsechnyMap[z.id] || 0,
    }));
    const wsZakazky = XLSX.utils.json_to_sheet(rowsZakazky);
    XLSX.utils.book_append_sheet(wb, wsZakazky, `Zakázky ${rok}`);

    XLSX.writeFile(wb, `vykazy_${rok}_${String(mesic).padStart(2,'0')}.xlsx`);
  };
 
  // Agregace podle ID zakázky, ne názvu
  const statZamestnanci = uzivatele
    .filter(u => u.role === 'zamestnanec' || u.role === 'vedouci')
    .map(u => ({
      ...u,
      hodiny: vykazy.mesic
        .filter(v => v.uzivatele?.jmeno === u.jmeno)
        .reduce((s, v) => s + parseFloat(v.hodiny), 0)
    }));
 
  const statZakazkyMesic = zakazky.map(z => ({
    ...z,
    hodiny: vykazy.mesic
      .filter(v => v.zakazky?.id === z.id)
      .reduce((s, v) => s + parseFloat(v.hodiny), 0)
  }));

  const statZakazkyVsechny = zakazky.map(z => ({
    ...z,
    hodiny: vykazy.vsechny
      .filter(v => v.zakazky?.id === z.id)
      .reduce((s, v) => s + parseFloat(v.hodiny), 0)
  }));

  const statZakazky = zakazkyPohled === 'mesic' ? statZakazkyMesic : statZakazkyVsechny;
 
  const celkemMesic = vykazy.mesic.reduce((s, v) => s + parseFloat(v.hodiny), 0);
  const maxHodiny = Math.max(...statZakazky.map(z => z.hodiny), 1);

  const zdrojDetail = zakazkyPohled === 'mesic' ? vykazy.mesic : vykazy.vsechny;
  const filtrovanyDetail = zdrojDetail.filter(v => {
    if (!hledani.trim()) return true;
    const h = hledani.toLowerCase();
    const datumCZ = v.datum ? v.datum.split('-').reverse().join('.') : '';
    return (
      v.uzivatele?.jmeno?.toLowerCase().includes(h) ||
      datumCZ.includes(h) ||
      v.datum?.includes(h) ||
      v.zakazky?.nazev?.toLowerCase().includes(h)
    );
  });
 
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111', marginBottom: 12 }}>Přehled</h2>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
          <select value={mesic} onChange={e => setMesic(+e.target.value)}
            style={{ border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', background: '#fff', outline: 'none' }}>
            {MESICE.map((m, i) => <option key={i} value={i+1}>{m}</option>)}
          </select>
          <select value={rok} onChange={e => setRok(+e.target.value)}
            style={{ border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', background: '#fff', outline: 'none' }}>
            {[2024,2025,2026,2027].map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          <button onClick={exportExcel}
            style={{ background: '#1b4332', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>
            ↓ Excel
          </button>
        </div>
      </div>
 
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginBottom: 20 }}>
        {[
          { label: 'Hodin tento měsíc', value: `${celkemMesic} h`, color: '#2d6a4f' },
          { label: 'Aktivní zakázky', value: zakazky.filter(z => !z.uzavrena).length, color: '#111' },
          { label: 'Zaměstnanci', value: uzivatele.filter(u => u.role === 'zamestnanec').length, color: '#555' },
        ].map((c, i) => (
          <div key={i} style={{ background: '#fff', borderRadius: 12, padding: '16px', borderTop: `3px solid ${c.color}`, boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: c.color }}>{c.value}</div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{c.label}</div>
          </div>
        ))}
      </div>
 
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['zamestnanci','👥 Zaměstnanci'],['zakazky','📋 Zakázky'],['detail','📄 Detail']].map(([val,lbl]) => (
          <button key={val} onClick={() => setTab(val)} style={{
            background: tab === val ? '#2d6a4f' : '#fff',
            color: tab === val ? '#fff' : '#555',
            border: '1.5px solid ' + (tab === val ? '#2d6a4f' : '#e2e8f0'),
            borderRadius: 20, padding: '7px 16px', fontSize: 13, fontWeight: 600,
            cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
          }}>{lbl}</button>
        ))}
      </div>
 
      {loading ? (
        <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#888' }}>Načítám…</div>
      ) : (
        <>
          {tab === 'zamestnanci' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {statZamestnanci.map(u => (
                <div key={u.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{u.jmeno}</div>
                    <div style={{ fontSize: 13, color: '#888', marginTop: 3 }}>
                      {u.role === 'vedouci' ? 'Vedoucí' : 'Zaměstnanec'}
                      {u.vedouci?.jmeno ? ` · ${u.vedouci.jmeno}` : ''}
                    </div>
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 22, color: '#2d6a4f' }}>{u.hodiny} h</div>
                </div>
              ))}
              {statZamestnanci.length === 0 && <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#888' }}>Žádní zaměstnanci</div>}
            </div>
          )}
 
          {tab === 'zakazky' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
                {[['mesic', `📅 ${MESICE[mesic-1]} ${rok}`], ['vsechny', '📊 Celkem']].map(([val, lbl]) => (
                  <button key={val} onClick={() => setZakazkyPohled(val)} style={{
                    background: zakazkyPohled === val ? '#2d6a4f' : '#fff',
                    color: zakazkyPohled === val ? '#fff' : '#555',
                    border: '1.5px solid ' + (zakazkyPohled === val ? '#2d6a4f' : '#e2e8f0'),
                    borderRadius: 20, padding: '6px 14px', fontSize: 13, fontWeight: 600,
                    cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
                  }}>{lbl}</button>
                ))}
              </div>
              {statZakazky.map(z => (
                <div key={z.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{z.nazev}</div>
                      <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                        {z.datum_zahajeni && `Od: ${z.datum_zahajeni}`}
                        {z.datum_ukonceni && ` · Do: ${z.datum_ukonceni}`}
                      </div>
                      <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                        {z.uzavrena ? '🔒 Uzavřena' : '✅ Aktivní'} · {zakazkyPohled === 'mesic' ? 'hodin tento měsíc' : 'hodin celkem'}
                      </div>
                    </div>
                    <div style={{ fontWeight: 800, fontSize: 22, color: z.uzavrena ? '#888' : '#2d6a4f', flexShrink: 0, marginLeft: 12 }}>{z.hodiny} h</div>
                  </div>
                  <div style={{ background: '#f0f0f0', borderRadius: 6, height: 8, overflow: 'hidden' }}>
                    <div style={{ background: z.uzavrena ? '#aaa' : '#2d6a4f', height: '100%', width: `${(z.hodiny / maxHodiny) * 100}%`, borderRadius: 6 }} />
                  </div>
                </div>
              ))}
            </div>
          )}
 
          {tab === 'detail' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
                {[['mesic', `📅 ${MESICE[mesic-1]} ${rok}`], ['vsechny', '📊 Celkem']].map(([val, lbl]) => (
                  <button key={val} onClick={() => setZakazkyPohled(val)} style={{
                    background: zakazkyPohled === val ? '#2d6a4f' : '#fff',
                    color: zakazkyPohled === val ? '#fff' : '#555',
                    border: '1.5px solid ' + (zakazkyPohled === val ? '#2d6a4f' : '#e2e8f0'),
                    borderRadius: 20, padding: '6px 14px', fontSize: 13, fontWeight: 600,
                    cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
                  }}>{lbl}</button>
                ))}
              </div>
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 16, color: '#aaa' }}>🔍</span>
                <input
                  type="text"
                  value={hledani}
                  onChange={e => setHledani(e.target.value)}
                  placeholder="Hledat podle jména, data nebo zakázky…"
                  style={{ border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '10px 14px 10px 36px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none', width: '100%', boxSizing: 'border-box', background: '#fff' }}
                />
                {hledani && (
                  <button onClick={() => setHledani('')} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#aaa' }}>✕</button>
                )}
              </div>
              {filtrovanyDetail.length === 0 ? (
                <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#888' }}>
                  {hledani ? `Žádné výkazy pro „${hledani}"` : 'Žádné schválené výkazy v tomto období'}
                </div>
              ) : filtrovanyDetail.map(v => (
                <div key={v.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{v.uzivatele?.jmeno}</div>
                    <div style={{ fontWeight: 800, fontSize: 20, color: '#2d6a4f' }}>{v.hodiny} h</div>
                  </div>
                  <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>📅 {v.datum} {v.cas_od && v.cas_do ? `(Od ${v.cas_od} do ${v.cas_do})` : ''}</div>
                  <div style={{ fontSize: 14, color: '#333', fontWeight: 500 }}>📋 {v.zakazky?.nazev}</div>
                  {v.poznamka && <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>💬 {v.poznamka}</div>}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
